module.exports = __webpack_public_path__ + "img/bronze.0c8d180e.png";